import styled from 'styled-components';
import { Input, Form } from 'antd';

export const FormItem = styled(Form.Item)`
    margin-bottom: ${props=> props.noMargin ? "0px" : "40px"}
`